import { useState } from 'react';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/material';
import { BoxSelector } from '../../component/BoxSelector';
import { ContextSelect } from '../../component/ContextSelect';
import { CustomerSelector } from '../../component/CustomerSelector';
import { SubmitButton } from '../../component/SubmitButton';
import Title from '../../component/Title';
import { boxStatus } from '../../enum/boxStatus';
import { customerRole } from '../../enum/customerRole';
import useAlert from '../../component/Alert/useAlert';
import BoxAPI from '../../services/box.api.service';


const NftReqBurn = () => {
    const {showSuccessAlert, showErrorAlert} = useAlert();
    const [state, setState] = useState({
        context: '',
        customer: '',
        box: '',
    });

    const changeState = partialState => setState(currentState => ({...currentState, ...partialState}));

    function handleSubmit() {
        changeState({loading: true});
        BoxAPI
            .freeze(state.box.hash, state.customer.id)
            .then(() => {
                showSuccessAlert('Request successfully sent');
                changeState({box: ''})
            })
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => changeState({loading: false}));
    }

    return (
        <Paper sx={{p: 4, display: 'flex', flexDirection: 'column', alignItems: 'left'}}>
            <Box
                component="form"
                noValidate={false}
                sx={{width: '100%'}}
            >
                <ContextSelect onContextChange={context => changeState({context})}/>
                <CustomerSelector
                    context={state.context}
                    roles={[customerRole.producer, customerRole.distributor, customerRole.reseller]}
                    onCustomerSelect={customer => changeState({customer})}
                />
                <Title sx={{mb: 1, mt: 2}}>Select a specific NFT</Title>
                <BoxSelector
                    customer={state.customer}
                    selectedBox={state.box}
                    onBoxChange={box => changeState({box})}
                    boxStatus={boxStatus.active}
                />
                <Box textAlign="center">
                    <SubmitButton
                        text="REQUEST NFT BURN"
                        loading={state.loading}
                        handleSubmit={handleSubmit}
                        disabled={state.loading || !state.box}
                    />
                </Box>
            </Box>
        </Paper>
    );
};

export default NftReqBurn;
